module.exports = __webpack_public_path__ + "img/hd.1f62b00c.png";